export default __webpack_public_path__ + "static/media/about.ad40953f.jpg";